module.exports = __webpack_public_path__ + "img/back_300.d6b61356.jpg";